import {
  Directive,
  Input,
  ElementRef,
  HostBinding,
  HostListener
} from '@angular/core';

@Directive({
  selector: '[appResizerHorizontal]'
})
export class ResizerHorizontalDirective {
  width: number;
  oldX = 0;
  grabber = false;
  @Input() minWidth;
  @Input() idOfWidthElementToGrab: string;

  constructor(private el: ElementRef) {}
  @HostBinding('style.width') divWidth;
  @HostListener('document:mousemove', ['$event'])
  onMouseMove(event: MouseEvent) {
    if (!this.grabber) {
      // if the div is in grab mode
      return;
    }

    this.resizer(event.clientX - this.oldX); // will be 1 or -1 depending on the direction
    this.oldX = event.clientX;
  }

  @HostListener('document:mouseup', ['$event'])
  onMouseUp(event: MouseEvent) {
    this.grabber = false; // stop grabbing
  }

  resizer(offsetX: number) {
    if (this.width + offsetX > this.minWidth) {
      // new width must be greater than min width
      this.width += offsetX;
      this.divWidth = this.width + 'px';
    }
  }

  @HostListener('mousedown', ['$event']) onResize(event: MouseEvent) {
    this.width = event.target['offsetWidth'];
    if (
      Math.abs(event.offsetX - this.width) <= 10 && // we want to make sure what is being clicked on and dragged is at the bottom of the div
      [...event.target['classList']].includes('resize-able') // whats clicked on must be the content
    ) {
      this.grabber = true;
      this.oldX = event.clientX;
      event.preventDefault(); // stops things like text being highlighted
    }
  }
}
